import { HttpClient } from "@angular/common/http";
import { Component, HostListener, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common/common.service";
import { ManualsService } from "src/app/services/manuals/manuals.service";
import { environment } from "src/environment/environment";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  loginId: any;
  name: any;
  userType: any;
  postObj: any;
  clientID: any;
  projectList: any;
  GetCustomersProjectList: any;
  customerActionLogsId: any;
  isMobileMenuOpen: boolean = false; // Track mobile menu state
  org_id:any;
  org_img:any;  
  org_data: any;
  //rajesh - for desktop view - right profile was not working
  dropdownOpen: boolean = false;
  softManualsDropdown: boolean = false;
  sparePartsDropdown: boolean = false;
  // State for dropdowns
  isDropdownOpen: { [key: string]: boolean } = {
    softManualsDropdown: false,
    sparePartsDropdown: false,
  };
  routerLinkVariable = "/dash";
  constructor(
    private router: Router,
    private commonService: CommonService,
    private ManualsService: ManualsService,
    private eRef: ElementRef,
    private AuthenticationService: AuthenticationService,
    private http: HttpClient,
    
  ) { }
  ngOnInit() {
    this.loginId = localStorage.getItem("user_id");
    this.name = localStorage.getItem("name");
    this.userType = localStorage.getItem("userType");
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    this.clientID = localStorage.getItem("customerId");
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    this.getOrgLogo();
    this.postObj = {
      customerId: this.clientID,
    }
    this.commonService.GetCustomersAllPOList(this.postObj).subscribe(
      (e: any) => {
        this.projectList = e.data;
      }
    );
    const payload = {
      "modelName": "project_spare_list",
      "whereCondition": {
        "customerId": this.clientID
      },
      "relations": [
        {
          "module": "project",
          "moduleAs": "projects",
          "subModule": "department",
          "subModuleAs": "departments"
        }
      ]
    }
    this.ManualsService.GetCustomersProjectList(payload).subscribe(
      (res: any) => {
        if (res.code == 1) {
          this.GetCustomersProjectList = res.data;
        }
      }
    );
  }
  // Handle clicks outside the dropdown to close it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    // Check if the click is inside the component
    if (!this.eRef.nativeElement.contains(targetElement)) {
      // Close all dropdowns
      this.softManualsDropdown = false;
      this.sparePartsDropdown = false;
      this.dropdownOpen = false;
      Object.keys(this.isDropdownOpen).forEach((key) => {
        this.isDropdownOpen[key] = false;
      });
    }
  }
  // Toggle dropdown visibility
  toggleDropdown(event: MouseEvent, dropdown: string) {
    event.stopPropagation();
    // Close all other dropdowns
    Object.keys(this.isDropdownOpen).forEach((key) => {
      if (key !== dropdown) {
        this.isDropdownOpen[key] = false; // Close other dropdowns
      }
    });
    if (dropdown == 'softManualsDropdown') {
      this.softManualsDropdown = !this.softManualsDropdown;
      this.sparePartsDropdown = false;
    }
    else {
      this.softManualsDropdown = false;
      this.sparePartsDropdown = !this.sparePartsDropdown;
    }
    // Toggle the clicked dropdown
    this.dropdownOpen = false;
    this.isDropdownOpen[dropdown] = !this.isDropdownOpen[dropdown];
  }
  gotomanuals(projectId: any,projectName: any) {
    this.softManualsDropdown = false;
    this.sparePartsDropdown = false;
    this.dropdownOpen = false;
    environment.projectName = projectName;
    this.router.navigate(["/manuals/" + projectId]);
    this.closeMobileMenu(); // Close the menu after navigation
  }
  SparePartDetailsComponent(projectId: any,projectName: any) {
    this.softManualsDropdown = false;
    this.sparePartsDropdown = false;
    this.dropdownOpen = false;
    environment.projectName = projectName;
    this.router.navigate(["/SparePartDetailsComponent/" + projectId]);
    this.closeMobileMenu(); // Close the menu after navigation
  }
  profile() {
    this.softManualsDropdown = false;
    this.sparePartsDropdown = false;
    this.dropdownOpen = false;
    this.router.navigate(["profile"]);
  }
  logout() {
    this.commonService
      .logout(this.customerActionLogsId)
      .subscribe((response: any) => {
        this.AuthenticationService.logoutUser();
        localStorage.clear();
        this.router.navigate(["/login"]);
      });
  }

  getOrgLogo() {
    this.org_id = localStorage.getItem("org_id");
    const postObj = {
      modelName: "organization_masters",
      whereCondition: {
        id: this.org_id,
      },
    };
    this.http
      .post<any>(`${environment.url}/common/getRecords`, postObj)
      .subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.org_data = response.data;            
            this.org_img = this.org_data?.[0]?.organization_logo 
            ? `${environment.pmsUrl}uploads/organization-logo/${this.org_data[0].organization_logo}` 
            : null;
        
          } else {
            console.log("No response");
          }
        },
        (error:any) => {
          console.error("Error for fetching org data:", error);
        }
      );
  }

  redirectToPage(link: any) {
    this.softManualsDropdown = false;
    this.sparePartsDropdown = false;
    this.dropdownOpen = false;
    this.router.navigate(["/" + link]);
  }
  //rajesh - for desktop view - right profile was not working
  toggleDropdownprofile() {
    this.softManualsDropdown = false;
    this.sparePartsDropdown = false;
    this.dropdownOpen = !this.dropdownOpen;
  }
  // Toggle mobile menu visibility
    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    // Close mobile menu
    closeMobileMenu() {
        this.isMobileMenuOpen = false;
    }

    // Navigate to a page
    navigateTo(link: string) {
        this.closeMobileMenu(); // Close the menu after navigation
        this.router.navigate([`/${link}`]);
    }
}